import ManageProducerCsvUpload from './ManageProductCsvUpload'

export default ManageProducerCsvUpload
